// @ts-nocheck
// datatable related plugins
import { yupResolver } from "@hookform/resolvers/yup";
import { ALL_BU, ALL_STORE } from "constants/DashboardContanst";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import {
  generateDateField,
  generateSelectField,
} from "helpers/form_helper_old";
import { convertDate } from "helpers/utils";
import { getInvoiceStatus } from "pages/IssueInvoice/helper/functionHelper";
import {
  FILE_NAME_REPORT,
  TYPE_REPORT,
} from "pages/ReportInvoiceError/helper/functionHelper";
import { getTimeContent } from "pages/ReportZipFile/helper/functionHelper";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useToasts } from "react-toast-notifications";
import { Button, Card, CardBody, Col, Label, Progress, Row } from "reactstrap";
import {
  DOWNLOAD_REPORT_INVOICE_FAIL,
  DOWNLOAD_REPORT_INVOICE_SUCCESS,
} from "store/summary-invoice-data/actionTypes";
import {
  createReportInvoice,
  downloadReportInvoice,
  resetDownloadReportInvoice,
  resetGetReportInvoiceProgress,
} from "store/summary-invoice-data/actions";
import * as yup from "yup";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const CreateData = props => {
  const [optionYear, setOptionYear] = useState(null);
  const [nameFile, setNameFile] = useState(null);
  const dispatch = useDispatch();

  const issueInvoice = useSelector(state => state.issueInvoice);
  const { currentTime } = issueInvoice;

  const initOptionDateLocale = {
    altInput: true,
    altFormat: "d/m/Y",
    dateFormat: "d/m/Y",
    allowInput: true,
    locale: {
      ...Vietnamese,
      firstDayOfWeek: 1,
    },
  };

  const [optionDateLocale, setOptionDateLocale] = useState({
    ...initOptionDateLocale,
  });

  // store reducer
  const summaryInvoiceData = useSelector(state => state.summaryInvoiceData);
  const {
    listKHHD,
    reportInvoiceProgress,
    createReportInvoiceData,
    type,
    fileDownload,
    fileDownloadName,
  } = summaryInvoiceData;

  const history = useHistory();

  const Dashboard = useSelector(state => state.Dashboard);
  const {
    buStoreHeader,
    listBuStore,
    buTenantHeaderInfo,
    finalBuInfo,
    buTenantHeader,
    tenantCodeHeader,
  } = Dashboard;

  useEffect(() => {
    if (buStoreHeader) {
      setValue("bu_code_filter", []);
      if (buStoreHeader === ALL_STORE) {
        setValue("is_all_store", true);
      } else {
        setValue("is_all_store", false);
      }
    }
  }, [buStoreHeader]);

  useEffect(() => {
    switch (type) {
      case DOWNLOAD_REPORT_INVOICE_SUCCESS: {
        if (fileDownload !== null) {
          const link = document.createElement("a");
          link.href = fileDownload;
          link.setAttribute("download", fileDownloadName);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetDownloadReportInvoice());
        break;
      }
      case DOWNLOAD_REPORT_INVOICE_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDownloadReportInvoice());
        break;
    }
  }, [type]);

  useEffect(() => {
    return () => {
      dispatch(resetGetReportInvoiceProgress());
    };
  }, []);

  useEffect(() => {
    if (currentTime) {
      let currentYear = currentTime?.data?.year;
      const listYear = [];
      for (let i = 0; i < 3; i++) {
        listYear.push({
          value: currentYear,
          label: "Năm " + currentYear,
        });
        currentYear = currentYear - 1;
      }
      setOptionYear(listYear);
      setValue("year", listYear[0]);
    }
  }, [currentTime]);

  const objectAll = {
    value: "All",
    label: "Tất cả",
  };

  useEffect(() => {
    if (listKHHD.data) {
      setValue("khhdon", objectAll);
    }
  }, [listKHHD]);

  const OPTION_TYPE_TIME = [
    {
      value: "quarter",
      label: "Quý",
    },
    {
      value: "month",
      label: "Tháng",
    },
    {
      value: "date",
      label: "Khoảng thời gian",
    },
  ];
  const { addToast } = useToasts();

  const OPTION_quarter = [
    {
      value: "01",
      label: "Quý 1",
    },
    {
      value: "02",
      label: "Quý 2",
    },
    {
      value: "03",
      label: "Quý 3",
    },
    {
      value: "04",
      label: "Quý 4",
    },
  ];

  const OPTION_MONTH = [
    {
      value: "01",
      label: "Tháng 1",
    },
    {
      value: "02",
      label: "Tháng 2",
    },
    {
      value: "03",
      label: "Tháng 3",
    },
    {
      value: "04",
      label: "Tháng 4",
    },
    {
      value: "05",
      label: "Tháng 5",
    },
    {
      value: "06",
      label: "Tháng 6",
    },
    {
      value: "07",
      label: "Tháng 7",
    },
    {
      value: "08",
      label: "Tháng 8",
    },
    {
      value: "09",
      label: "Tháng 9",
    },
    {
      value: "10",
      label: "Tháng 10",
    },
    {
      value: "11",
      label: "Tháng 11",
    },
    {
      value: "12",
      label: "Tháng 12",
    },
  ];

  const { t, i18n } = useTranslation(["summaryInvoiceData"]);
  const [commonStatus, setCommonStatus] = useState(getInvoiceStatus(t));

  const schema = yup.object().shape({
    // THông tin chung
    is_all_store: yup.boolean(),
    typeTime: yup.object(),
    quarter: yup.object(),
    month: yup.object(),
    year: yup.object(),
    dateRange: yup.array().when(["typeTime"], {
      is: typeTime => typeTime.value === OPTION_TYPE_TIME[2].value,
      then: yup
        .array()
        .min(1, "Vui lòng chọn khoảng thời gian muốn xuất bảng kê"),
    }),
    // bu_code_filter: yup
    //   .array()
    //   .min(1, "Vui lòng chọn đơn vị/chi nhánh")
    //   .nullable(),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
    setFocus,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      typeTime: OPTION_TYPE_TIME[2],
      quarter: OPTION_quarter[0],
      month: OPTION_MONTH[0],
      bu_code_filter: [],
      dateRange: [],
    },
  });

  const onSubmit = values => {
    console.log("🚀 ~ file: CreateData.js ~ line 284 ~ values", values);
    setNameFile(null);
    const { month, quarter, typeTime, year, bu_code_filter } = values;
    let params = null;
    if (typeTime.value === "quarter") {
      params = {
        quarter: quarter.value,
        year: year.value,
        // kyhieu: khhdon.value !== objectAll.value ? khhdon.value : undefined,
      };
    }
    if (typeTime.value === "month") {
      params = {
        month: month.value,
        year: year.value,
        // kyhieu: khhdon.value !== objectAll.value ? khhdon.value : undefined,
      };
    }
    if (typeTime.value === "date") {
      params = {
        date_from: convertDate(values.dateRange[0], "date"),
        date_to: convertDate(
          values.dateRange[1] ? values.dateRange[1] : values.dateRange[0],
          "date"
        ),
        // kyhieu: khhdon.value !== objectAll.value ? khhdon.value : undefined,
      };
    }
    params = {
      ...params,
      // bu_code: buStoreHeader === ALL_STORE ? buTenantHeader : buStoreHeader,
      // bu_code_filter:
      //   buStoreHeader === ALL_STORE
      //     ? bu_code_filter.map(item => item.value)
      //     : [buStoreHeader],
    };
    setNameFile(FILE_NAME_REPORT.TAX_DEDUCT_TRANSFER + getTimeContent(params));
    dispatch(
      createReportInvoice({ ...params }, TYPE_REPORT.TAX_DEDUCT_TRANSFER)
    );
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>
            Lập báo cáo đối soát truyền nhận chứng từ khấu trừ thuế thu nhập cá
            nhân
          </title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs
            title=""
            breadcrumbItem={
              "Lập báo cáo đối soát truyền nhận chứng từ khấu trừ thuế thu nhập cá nhân"
            }
          />
          <Card>
            <CardBody style={{ minHeight: "450px" }}>
              <Row className="row-cols-1 row-cols-md-3">
                {/* Loại */}
                <Col style={{}}>
                  {generateSelectField(
                    "Loại",
                    true,
                    errors,
                    "typeTime",
                    "Vui lòng chọn",
                    false,
                    control,
                    OPTION_TYPE_TIME,
                    "auto",
                    () => {
                      //   const cqtqly = getValues(COMMON_FIELD.CQTQLY.field);
                      //   if (cqtqly?.code) {
                      //     setValue(COMMON_FIELD.MCQTQLY.field, cqtqly.code, {
                      //       shouldValidate: true,
                      //     });
                      //   }
                    },
                    false
                  )}
                </Col>
                {watch("typeTime").value === OPTION_TYPE_TIME[0].value && (
                  <Col style={{}}>
                    {generateSelectField(
                      "Quý",
                      true,
                      errors,
                      "quarter",
                      "Vui lòng chọn",
                      false,
                      control,
                      OPTION_quarter,
                      "auto",
                      () => {
                        //   const cqtqly = getValues(COMMON_FIELD.CQTQLY.field);
                        //   if (cqtqly?.code) {
                        //     setValue(COMMON_FIELD.MCQTQLY.field, cqtqly.code, {
                        //       shouldValidate: true,
                        //     });
                        //   }
                      },
                      false
                    )}
                  </Col>
                )}
                {watch("typeTime").value === OPTION_TYPE_TIME[1].value && (
                  <Col style={{}}>
                    {generateSelectField(
                      "Tháng",
                      true,
                      errors,
                      "month",
                      "Vui lòng chọn",
                      false,
                      control,
                      OPTION_MONTH,
                      "auto",
                      () => {
                        //   const cqtqly = getValues(COMMON_FIELD.CQTQLY.field);
                        //   if (cqtqly?.code) {
                        //     setValue(COMMON_FIELD.MCQTQLY.field, cqtqly.code, {
                        //       shouldValidate: true,
                        //     });
                        //   }
                      },
                      false
                    )}
                  </Col>
                )}
                {watch("typeTime").value === OPTION_TYPE_TIME[2].value && (
                  <Col style={{}}>
                    {generateDateField(
                      "Từ ngày",
                      "Đến ngày",
                      false,
                      errors,
                      "dateRange",
                      "DD/MM/YYYY ~ DD/MM/YYYY",
                      false,
                      control,
                      {
                        ...optionDateLocale,
                        mode: "range",
                        // enableTime: true,
                        // dateFormat: "Y-m-d",
                        // dateFormat: "H:i",
                        // time_24hr: true,
                      }
                    )}
                  </Col>
                )}
                {watch("typeTime").value !== OPTION_TYPE_TIME[2].value && (
                  <Col style={{}}>
                    {generateSelectField(
                      "Năm",
                      true,
                      errors,
                      "year",
                      "Vui lòng chọn",
                      false,
                      control,
                      optionYear,
                      "auto",
                      () => {
                        //   const cqtqly = getValues(COMMON_FIELD.CQTQLY.field);
                        //   if (cqtqly?.code) {
                        //     setValue(COMMON_FIELD.MCQTQLY.field, cqtqly.code, {
                        //       shouldValidate: true,
                        //     });
                        //   }
                      },
                      false
                    )}
                  </Col>
                )}
              </Row>
              {/* <Row className="row-cols-1 row-cols-md-3 mt-2">
                <Col style={{}}>
                  {generateSelectField(
                    listBuStore?.length > 0 ? "Đơn vị" : "Chi nhánh",
                    true,
                    errors,
                    "bu_code_filter",
                    "Vui lòng chọn",
                    false,
                    control,
                    buStoreHeader === ALL_STORE
                      ? listBuStore && [
                          {
                            value: "all",
                            label: "Tất cả",
                          },
                          ...listBuStore.filter(
                            item => item.value !== ALL_STORE
                          ),
                        ]
                      : [
                          {
                            value: finalBuInfo?.code,
                            label: finalBuInfo?.code + " - " + finalBuInfo?.ten,
                          },
                        ],
                    "auto",
                    e => {
                      if (e.findIndex(item => item.value === "all") !== -1) {
                        setValue(
                          "bu_code_filter",
                          listBuStore.filter(item => item.value !== ALL_STORE)
                        );
                      }
                    },
                    false,
                    false,
                    false,
                    true
                  )}
                </Col>
              </Row> */}
              <div className="mt-4 d-flex justify-content-center gap-2">
                <Button
                  color="danger"
                  className=" w-md"
                  type="submit"
                  onClick={() => {
                    history.push("/tax-deduct/list-report-transfer");
                  }}
                >
                  Trở về
                </Button>
                <Button
                  type="button"
                  color="primary"
                  className="me-2 btn-label"
                  disabled={
                    createReportInvoiceData.loading ||
                    reportInvoiceProgress.isStart
                    // ||
                    // buStoreHeader === ALL_BU
                  }
                  onClick={() => {
                    handleSubmit(onSubmit)();
                  }}
                >
                  <i className="bx bxs-report label-icon" />
                  Tạo bảng kê hóa đơn
                </Button>
              </div>
              {(reportInvoiceProgress.isStart ||
                reportInvoiceProgress.percent !== 0) && (
                  <React.Fragment>
                    <Row className="mt-3 d-flex justify-content-center">
                      <div style={{ width: "80vw", height: "33px" }}>
                        <Label>
                          {" "}
                          <div className="d-flex justify-content-center align-items-end gap-2">
                            <i className=" far fa-file-excel text-success font-size-20" />
                            <strong>{nameFile + ".xlsx "}</strong>
                            {reportInvoiceProgress.percent === 100
                              ? ""
                              : "(Đang xử lý)"}
                          </div>
                        </Label>

                        <Progress
                          style={{ height: "33px" }}
                          animated
                          color="info"
                          striped
                          value={reportInvoiceProgress.percent}
                        >
                          <span style={{ fontSize: "20px" }}>
                            {reportInvoiceProgress.percent === 100 &&
                              "Hoàn tất xử lý"}{" "}
                            ({reportInvoiceProgress.percent + "%"})
                          </span>
                        </Progress>
                      </div>
                    </Row>
                    {reportInvoiceProgress.percent === 100 && (
                      <Row className="mt-4 d-flex justify-content-center">
                        <div
                          onClick={() => {
                            dispatch(
                              downloadReportInvoice(
                                reportInvoiceProgress.id,
                                nameFile,
                                "blob",
                                ".xlsx",
                                TYPE_REPORT.TAX_DEDUCT_TRANSFER
                              )
                            );
                          }}
                          className="mt-2 font-size-18 text-success d-flex align-items-center"
                          style={{ width: "fit-content", cursor: "pointer" }}
                        >
                          <i className="bx bx-download label-icon " />
                          Tải báo cáo
                        </div>
                      </Row>
                    )}
                  </React.Fragment>
                )}
            </CardBody>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CreateData;
